import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Paper, Box, CircularProgress, Alert } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import StarIcon from '@mui/icons-material/Star';
import useTabVisibility from '../../hooks/useTabVisibility'

import ChangeMultidevices from "../../components/ChangeMultidevices";

function GeneratingQrCode() {
  return <QueryParams />;
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const optionDate = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
}

function QueryParams() {
  const isTabActive = useTabVisibility()

  const [timeInterval, setTimeInterval] = useState(0);
  const [qrCode, setQrCode] = useState("");
  const [lastUpdated, setLastUpdated] = useState("");
  const [integrationProvider, setIntegrationProvider] = useState('')
  const [error, setError] = useState('')
  const [queryParameters] = useSearchParams()
  const [isLoadingQrCode, setIsLoadingQrCode] = useState(true)
  const [qrCodeExpired, setQrCodeExpired] = useState(false)
  const [server, setServer] = useState('')
  const [timeoutReference, setTimeoutReference] = useState(undefined)

  let query = useQuery();

  const getInstanceInformations = () => {
    const options = {
      method: 'POST',
      url: `${process.env.REACT_APP_BASE_URL_API}/instances/microservices/informations`,
      headers: { 'Content-Type': 'application/json' },
      data: {
        clientApi: queryParameters.get('api'),
        clientSecret: queryParameters.get('secret')
      }
    }

    axios(options)
      .then(response => {
        setIntegrationProvider(response.data.provider || 'hiperapi-v1')
        setServer(response.data.numberServer)
      })
  }

  const handleIntegrationProviderChange = (e) => {
    setTimeInterval(0)
    setIntegrationProvider(e.target.value)
  }

  const handleQrCodeLastUpdated = (date) => {
    setLastUpdated(new Date(date).toLocaleDateString('pt-br', optionDate))
  }

  const generateQrCodeHiperApiV2 = async () => {
    try {
      setError('')
      if(integrationProvider !== 'hiperapi-v2') return

      const url = `${process.env.REACT_APP_BASE_URL_API}/instances/microservices/generateQRCode/hiperapi-v2`
      const response = await requestGenerateQrCode(url)

      setQrCode(response.data.base64Qr)
      handleQrCodeLastUpdated(response.data.updated_at)
    } catch (error) {
      console.error(error)
      setQrCode('')
      setError(error.message)
    }
    setIsLoadingQrCode(false)
  }

  const generateQrCodeHiperApiV1 = async () => {
    try {
      setError('')
      if(integrationProvider !== 'hiperapi-v1') return

      const url = `${process.env.REACT_APP_BASE_URL_API}/instances/microservices/generateQRCode/hiperapi-v1`
      const response = await requestGenerateQrCode(url)

      setQrCode(response.data.base64Qr)
      handleQrCodeLastUpdated(response.data.updated_at)
    } catch (error) {
      console.error(error)
      setQrCode('')
      setError(error.message)
    }
    setIsLoadingQrCode(false)
  }

  const requestGenerateQrCode = async (url = '') => {
    const data = {
      clientApi: query.get('api'),
      clientSecret: query.get('secret')
    }
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    }
    return axios.post(url, data, config)
  }

  const generateQrCode = () => {
    if(!integrationProvider) return
    setIsLoadingQrCode(true)
    setQrCodeExpired(false)
    setTimeInterval(0)
    generateQrCodeHiperApiV2()
    generateQrCodeHiperApiV1()
  }

  useEffect(() => {
    generateQrCode()
  }, [integrationProvider]);

  useEffect(() => {
    getInstanceInformations()
  }, [])

  const stylePaper = {
    margin: 10,
    padding: 10,
  };

  useEffect(() => {
    if(timeInterval === 5) {
      generateQrCode()
      setTimeInterval(0)
    }
  }, [timeInterval])

  useEffect(() => {
    if(!isTabActive) {
      setQrCodeExpired(true)
    }
  }, [isTabActive])

  useEffect(() => {
    if(timeoutReference) clearTimeout(timeoutReference)
    const timeout = setTimeout(() => setTimeInterval(timeInterval => timeInterval + 1), 1000)
    setTimeoutReference(timeout)
  }, [timeInterval])

  useEffect(() => {
    return () => timeoutReference && clearTimeout(timeoutReference)
  }, [timeoutReference])

  return (
    <Paper elevation={6} style={stylePaper}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-evenly",
          p: 2,
          m: 2,
          bgcolor: "background.paper",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div style={{ width: 300, marginBottom: 20 }}>
            <p>Versões</p>
            <div style={{ marginTop: -15 }}>
              <Select
                labelId="integration-providers-label"
                id="integration-providers"
                fullWidth
                value={integrationProvider}
                onChange={handleIntegrationProviderChange}
              >
                <MenuItem value="hiperapi-v1">HiperAPI V1 - Whatsapp Web</MenuItem>
              </Select>
            </div>
          </div>
          <label style={{ color: "#707070", fontSize: 16 }}>
            ✅ QRCode atualizado em: <strong style={{ color: "green" }}>{lastUpdated}</strong>.
          </label>
          { error && <label>{error}</label> }
          <div style={{ position: 'relative', width: 300, height: 300 }}>
            <img style={{ padding: 20 }} width={300} height={300} src={qrCode} />
            {
              (isLoadingQrCode || qrCodeExpired) &&
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <div style={{ backgroundColor: 'white', opacity: 0.95, width: '100%', height: '100%', position: 'absolute' }} />
                { isLoadingQrCode && <CircularProgress style={{ position: 'relative' }} /> }
                {
                  qrCodeExpired &&
                  <div
                    style={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column'
                    }}
                  >
                    <p>qrcode expirado</p>
                    <button onClick={generateQrCode}>Gerar novo QR Code</button>
                  </div>
                }
              </div>
            }
          </div>
          <label style={{ marginBottom: 10 }}>Qrcode <strong>{integrationProvider.toLowerCase()}</strong></label>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <ChangeMultidevices />
        </Box>
      </Box>
    </Paper>
  );
}

export default GeneratingQrCode;
